import { render, staticRenderFns } from "./Variants2Tab.vue?vue&type=template&id=4444f46a&"
import script from "./Variants2Tab.vue?vue&type=script&lang=ts&"
export * from "./Variants2Tab.vue?vue&type=script&lang=ts&"
import style0 from "./Variants2Tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports